import React from 'react';
import { Box, Container, Paper, Tab, Tabs } from '@mui/material';
import {
  Assessment,
  Schedule as ScheduleIcon,
  History,
  HealthAndSafety,
  Terminal,
  Bolt,
  Error as ErrorIcon,
  ManageHistory,
  NotificationsActive,
} from '@mui/icons-material';
import SectionTitle from './crt/SectionTitle';
import OverviewTab from './admin/OverviewTab';
import ScheduleTab from './admin/ScheduleTab';
import RunsTab from './admin/RunsTab';
import AuditTab from './admin/AuditTab';
import LogsTab from './admin/LogsTab';
import WorkersTab from './admin/WorkersTab';
import ErrorsTab from './admin/ErrorsTab';
import ActionsTab from './admin/ActionsTab';
import AlertsTab from './admin/AlertsTab';

import { useUrlIntState } from '../hooks/useUrlState';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => (
  <div role="tabpanel" hidden={value !== index}>
    {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
  </div>
);

const AdminDashboard: React.FC = () => {
  const [active, setActive] = useUrlIntState('adm_tab', 0);

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box mb={4}>
        <SectionTitle sub="&gt; ETL jobs, DB health, system activity_">
          ADMIN :: OPERATIONS CONSOLE
        </SectionTitle>
      </Box>

      <Paper sx={{ mb: 3 }}>
        <Tabs
          value={active}
          onChange={(_, v) => setActive(v)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab icon={<Assessment />} label="Overview" />
          <Tab icon={<ScheduleIcon />} label="Schedule" />
          <Tab icon={<History />} label="Runs" />
          <Tab icon={<HealthAndSafety />} label="Audit" />
          <Tab icon={<Terminal />} label="Logs" />
          <Tab icon={<Bolt />} label="Workers" />
          <Tab icon={<ErrorIcon />} label="Errors" />
          <Tab icon={<ManageHistory />} label="Actions" />
          <Tab icon={<NotificationsActive />} label="Alerts" />
        </Tabs>
      </Paper>

      <TabPanel value={active} index={0}><OverviewTab /></TabPanel>
      <TabPanel value={active} index={1}><ScheduleTab /></TabPanel>
      <TabPanel value={active} index={2}><RunsTab /></TabPanel>
      <TabPanel value={active} index={3}><AuditTab /></TabPanel>
      <TabPanel value={active} index={4}><LogsTab /></TabPanel>
      <TabPanel value={active} index={5}><WorkersTab /></TabPanel>
      <TabPanel value={active} index={6}><ErrorsTab /></TabPanel>
      <TabPanel value={active} index={7}><ActionsTab /></TabPanel>
      <TabPanel value={active} index={8}><AlertsTab /></TabPanel>
      {/* AdminLoginDialog moved to App.tsx for global availability —
          listens for 401s from any admin endpoint (e.g. Megaphone
          publish wizard), not just this dashboard. */}
    </Container>
  );
};

export default AdminDashboard;
